(ns machtfit.repository.offer-layers
  (:require [machtfit.api :as api]
            [machtfit.repository.core :as repository]
            [machtfit.repository.query :as query]
            [re-frame.core :as rf])
  (:require-macros [reagent.ratom :refer [reaction]]))

(def ^:private db-path
  (conj repository/db-path-base :offer-layers))

(rf/reg-event-fx ::store
  (fn [{:keys [db]} [_ result]]
    {:db (assoc-in db db-path {:status :done
                               :offer-layers result})}))

(rf/reg-event-fx ::fetch
  (fn [{:keys [db]} _]
    (if (query/running? db [::fetch])
      {}
      {:dispatch [::query/register [::fetch]]
       :post (api/request db
                          {:data '[(:offer-layers-data {} :offer-layers)]
                           :on-error #(rf/dispatch [::query/unregister [::fetch]])
                           :on-success #(do
                                          (rf/dispatch [::query/unregister [::fetch]])
                                          (rf/dispatch [::store (-> % :result :offer-layers :result)]))})})))

(rf/reg-sub-raw ::data
  (fn [_ _]
    (reaction
     (repository/async-query-data db-path #(rf/dispatch [::fetch])))))
